const initState = {
    users: [],
}

export const matchedUserReducer = (state = initState, action) => {
    const {type, payload} = action
    switch (type) {
        case 'MATCHED_USERS':
                return {users: payload}
        default:
            return state
    }

}
